import { useEffect } from 'react';

export const useClickOutside = (ref: React.MutableRefObject<HTMLElement | null>, fn: () => void, refExclude?: React.MutableRefObject<HTMLElement | null>) => {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event: any) => {
            if (ref && ref.current && !ref.current.contains(event.target) && !refExclude?.current?.contains(event.target)) {
                fn();
            }
        };

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};
